import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import logoWhite from "../images/br-plast-low-resolution-logo-white-on-transparent-background.png";

const Footer = () => {
  function scrollUp() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <Container>
      <FooterGrid>
        <CompanyCol>
          <img src={logoWhite} alt="BR Plast" style={{ height: 48, display: "block", marginBottom: 20 }} />
          <CompanyDesc>
            India's trusted manufacturer and trader of plastic packaging films.
            Custom printing. Pan-India delivery.
          </CompanyDesc>
        </CompanyCol>

        <LinksCol>
          <ColHeading>Navigation</ColHeading>
          <NavList>
            <li><Link to="/" onClick={scrollUp}>Home</Link></li>
            <li><Link to="/products" onClick={scrollUp}>Products</Link></li>
            <li><Link to="/contact" onClick={scrollUp}>Contact Us</Link></li>
          </NavList>
        </LinksCol>

        <ProductsCol>
          <ColHeading>Product Lines</ColHeading>
          <NavList>
            <li><Link to="/product/1" onClick={scrollUp}>BOPP Films</Link></li>
            <li><Link to="/product/2" onClick={scrollUp}>POF Shrink Films</Link></li>
            <li><Link to="/product/3" onClick={scrollUp}>LD Poly Bags</Link></li>
            <li><Link to="/product/4" onClick={scrollUp}>HM Bags</Link></li>
          </NavList>
        </ProductsCol>

        <ContactCol>
          <ColHeading>Contact</ColHeading>
          <ContactList>
            <li>+91 9323582798</li>
            <li>brplastm@gmail.com</li>
          </ContactList>
          <Link to="/contact" onClick={scrollUp}>
            <EnquiryBtn>Send Enquiry</EnquiryBtn>
          </Link>
        </ContactCol>
      </FooterGrid>

      <Divider />

      <BottomRow>
        <p>© 2025 BR Plast. All rights reserved.</p>
        <p>Plastic Packaging Manufacturer &amp; Trader, India</p>
      </BottomRow>
    </Container>
  );
};

const Container = styled.footer`
  padding: 72px 80px 32px;
  background-color: var(--color-dark);
  color: white;

  @media (max-width: 768px) {
    padding: 48px 24px 24px;
  }
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.4fr;
  gap: 48px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const CompanyCol = styled.div``;

const CompanyDesc = styled.p`
  font-size: 14px;
  color: rgba(255,255,255,0.4);
  line-height: 1.7;
  margin: 0;
  max-width: 280px;
`;

const ColHeading = styled.h4`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: rgba(255,255,255,0.3);
  margin: 0 0 20px;
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 2px;
  }

  li a {
    text-decoration: none;
    color: rgba(255,255,255,0.55);
    font-size: 14px;
    font-weight: 400;
    display: block;
    padding: 5px 0;
    transition: var(--transition);

    &:hover {
      color: rgba(255,255,255,0.9);
      padding-left: 4px;
    }
  }
`;

const LinksCol = styled.div``;
const ProductsCol = styled.div``;
const ContactCol = styled.div``;

const ContactList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 20px;

  li {
    color: rgba(255,255,255,0.55);
    font-size: 14px;
    padding: 5px 0;
  }
`;

const EnquiryBtn = styled.button`
  background: var(--color-accent);
  color: white;
  border: none;
  border-radius: var(--radius-btn);
  padding: 11px 24px;
  font-size: 13px;
  font-weight: 700;
  font-family: var(--font-primary);
  cursor: pointer;
  transition: var(--transition);
  letter-spacing: 0.5px;
  text-transform: uppercase;

  &:hover {
    background: #c97820;
    transform: translateY(-2px);
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid rgba(255,255,255,0.06);
  margin: 48px 0 24px;
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    color: rgba(255,255,255,0.2);
    font-size: 12px;
    margin: 0;
    letter-spacing: 0.3px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 6px;
    text-align: center;
  }
`;

export default Footer;
